/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import moment from "moment-timezone";

import { DataTableList } from '../../../components/DataTable/DataTableList';
import TopBar from '../../../components/TopBar';
import DeleteConfirmationPopup from '../../../components/DeleteConfirmationPopup';
import AddCategory from './AddCategory';
import { createBlogCategory, updateBlogCategory, getBlogCategories, getAllBlogCategories, deleteBlogCategory } from '../../../api/blogCategoryApi';
import { getAllBanners } from '../../../api/bannerApi';

import Delete from "../../../assets/images/delete.svg";
import penIcon from "../../../assets/images/pen-img.svg";
import searchIcon from "../../../assets/images/icon-search.svg";

import styles from '../blog.module.css'

const AllCategories = () => {
  const popupRef = useRef()
  const addPopupRef = useRef()
  const parentDropdownRef = useRef()
  const bannerDropdownRef = useRef()

  const [categoryList, setCategoryList] = useState([])
  const [allCategoryList, setAllCategoryList] = useState([])
  const [bannerList, setBannerList] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoadingFetchData, setIsLoadingFetchData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [columnWidths, setColumnWidths] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [toggleSelect, setToggleSelect] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showAddCategoryPopup, setShowAddCategoryPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    description: '',
    parent: '',
    bannerId: ''
  });
  const [errorMessage, setErrorMessage] = useState({});
  const [error, setError] = useState('');
  const [openParent, setOpenParent] = useState(false);
  const [openBanner, setOpenBanner] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [isSlugChanged, setIsSlugChanged] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (parentDropdownRef.current && !parentDropdownRef.current.contains(event.target)) {
        setOpenParent(false);
      }
      if (bannerDropdownRef.current && !bannerDropdownRef.current.contains(event.target)) {
        setOpenBanner(false);
      }
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowDeletePopup(false);
      }
      if (addPopupRef.current && !addPopupRef.current.contains(event.target)) {
        setShowAddCategoryPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const calculateColumnWidths = async () => {
    return new Promise((resolve) => {
      const tempWidths = categoryList?.reduce((acc, row) => {
        Object.keys(row).forEach((key) => {
          const dataValue = row[key]?.toString();
          const title = row[key];
          let maxContentLength = Math.max(dataValue?.length, title?.length);
          if (!acc[key] || maxContentLength > acc[key]) {
            acc[key] = maxContentLength;
          }
        });
        return acc;
      }, {});

      if (tempWidths !== undefined) {
        const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
          acc[key] = `${tempWidths[key] * 10 + 40}px`;
          return acc;
        }, {});
        setColumnWidths(widthMap);
      }
      resolve();
    });
  };

  useEffect(() => {
    if (categoryList?.length > 0) {
      calculateColumnWidths();
    }
  }, [categoryList]);

  useEffect(() => {
    if (Object.keys(columnWidths).length > 0) {
      setTimeout(() => {
        setIsLoadingData(false);
      }, 1000);
    }
  }, [columnWidths]);

  const handleMasterCheckboxChange = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(categoryList?.map((row) => row?.categoryId));
    }
    setIsAllSelected(!isAllSelected);
  };

  const columns = [
    {
      name: 'Category Name',
      selector: (row) => row?.name,
      cell: (row) => <div className='editTitle'>{'—'.repeat(row.level)} {row.name}</div>,
      sortable: true,
      minWidth: columnWidths['name'] ? `${parseInt(columnWidths['name']) + 50}px` : '200px',
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
    },
    {
      name: 'Created Date',
      selector: (row) => row?.createdAt,
      cell: (row) => <div>{moment(row?.createdAt).format('MMM DD, YYYY')}</div>,
      sortable: true,
      width: '150px',
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="action-buttons">
          <button className="edit-btn" onClick={() => {
            const selectedBanner = bannerList?.filter((item) =>
              row?.bannerId?.some((banner) => item.bannerId === banner)
            );
            const blogcategoryDataItem = {
              ...row,
              bannerId: selectedBanner?.length > 0 ? selectedBanner : []
            }

            setFormData(blogcategoryDataItem);

            setShowAddCategoryPopup(true);
            setError('')
          }}><img src={penIcon} alt="pen-icon" /></button>
          <button className="delete-btn" onClick={() => {
            setDeleteTarget({ type: "single", row });
            setShowDeletePopup(true);
          }}><img src={Delete} alt="delete-icon" /></button>
        </div>
      ),
      width: "90px"
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: 500,
        fontSize: '14px',
      },
    },
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setIsLoading(true);
    try {
      if (deleteTarget.type === "single") {
        const deletedCategory = deleteTarget.row;
        const categoryId = deletedCategory?.categoryId;
        if (!categoryId) return;

        const response = await deleteBlogCategory(categoryId);
        if (!response?.success) return;

        const index = categoryList.findIndex(c => c.categoryId === categoryId);
        if (index === -1) return;

        const { endIndex } = getDescendants(categoryList, index, deletedCategory.level);
        const updatedList = [
          ...categoryList.slice(0, index),
          ...categoryList.slice(endIndex),
        ];
        setCategoryList(updatedList);
      }

      if (deleteTarget.type === "multiple") {
        const idsToDelete = new Set(deleteTarget.rows);
        let updatedList = [];
        let i = 0;
        while (i < categoryList.length) {
          const item = categoryList[i];
          if (idsToDelete.has(item.categoryId)) {
            const { endIndex } = getDescendants(categoryList, i, item.level);
            i = endIndex;
          } else {
            updatedList.push(item);
            i++;
          }
        }
        await Promise.all([...idsToDelete].map(id => deleteBlogCategory(id)));
        setCategoryList(updatedList);
        setSelectedRows([]);
        setIsAllSelected(false);
        setToggleSelect(prev => !prev);
      }

      setShowDeletePopup(false);
      setDeleteTarget(null);
      fetchAllCategoryData()
    } catch (error) {
      const message = error.response?.data?.message || "Something went wrong. Please try again.";
      setError(message);
      console.error("Delete error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getDescendants = (list, parentIndex, parentLevel) => {
    let descendants = [];
    let i = parentIndex + 1;
    while (i < list.length && list[i].level > parentLevel) {
      descendants.push(list[i]);
      i++;
    }
    return { descendants, endIndex: i };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errorMessage[name]) {
      setErrorMessage(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleParentSelect = (cat) => {
    setFormData(prev => ({
      ...prev,
      parent: cat?.categoryId
    }));
    setOpenParent(false);
  };

  const getParentId = (parent) => {
    if (!parent) return null;
    if (typeof parent === 'number') return parent;
    if (typeof parent === 'object') return parent?.categoryId || null;
    return parent ? Number(parent) : null;
  };

  const handleBannerSelect = (banner) => {
    setFormData(prev => {
      const currentBanners = Array.isArray(prev?.bannerId) ? prev.bannerId : (prev?.bannerId ? [prev.bannerId] : []);
      const exists = currentBanners.some(b => b?.bannerId === banner?.bannerId);
      let newBanners;
      if (exists) {
        newBanners = currentBanners.filter(b => b?.bannerId !== banner?.bannerId);
      } else {
        newBanners = [...currentBanners, banner];
      }
      return { ...prev, bannerId: newBanners };
    });
  };

  const fetchData = async () => {
    try {
      setIsLoadingFetchData(true)
      setIsLoadingData(true)
      const response = await getBlogCategories({
        page: currentPage,
        search: searchInput,
      });

      if (response?.data?.result?.length <= 0) {
        setIsLoadingData(false)
      }
      setCategoryList(response?.data?.result);
      setTotalPage(response?.data?.totalPages || 1);
      setIsLoadingFetchData(false)
    } catch (error) {
      setIsLoadingData(false)
      setIsLoadingFetchData(false)
      console.log(error, "error");
    }
  }

  const fetchAllCategoryData = async () => {
    try {
      const response = await getAllBlogCategories();
      setAllCategoryList(response?.data || []);
    } catch (error) {
      setAllCategoryList([])
      console.log(error, "error");
    }
  }

  const fetchBannerData = async () => {
    try {
      const response = await getAllBanners()
      setBannerList(response?.data || [])
    } catch (error) {
      setBannerList([])
      console.log(error, "error");
    }
  }

  useEffect(() => {
    fetchBannerData()
    fetchAllCategoryData()
  }, [])

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const handleSubmit = async () => {
    const errors = {};

    if (!formData?.name?.trim()) errors.name = "Category name is required";
    if (!formData?.slug?.trim()) errors.slug = "Category URL is required";
    // if (!formData?.image?.trim()) errors.image = "Image is required";
    // if (!formData?.description?.trim()) errors.description = "Description is required";

    if (Object.keys(errors).length) {
      setErrorMessage(errors);
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        name: formData?.name.trim(),
        slug: formData?.slug?.trim(),
        description: formData?.description?.trim() || "",
        parent: getParentId(formData?.parent),
        bannerId: formData?.bannerId?.length > 0 ? formData?.bannerId?.map(banner => banner?.bannerId) : null,
        ...(formData?.categoryId && { categoryId: formData?.categoryId }),
      };

      const response = formData.categoryId
        ? await updateBlogCategory(payload)
        : await createBlogCategory(payload);

      if (!response?.success) return;

      const category = response?.data;

      const newCategory = {
        categoryId: category?.categoryId,
        name: category?.name,
        slug: category?.slug,
        description: category?.description || '',
        parent: getParentId(category?.parent),
        level: getParentId(category?.parent)
          ? categoryList?.find(c => c.categoryId === getParentId(category?.parent))?.level + 1
          : 0,
        createdAt: category?.createdAt || new Date().toISOString(),
        bannerId: formData?.bannerId?.length > 0 ? formData?.bannerId?.map(banner => banner?.bannerId) : null,
      };

      let updatedList = [...categoryList];

      if (!formData?.categoryId) {
        if (newCategory.parent) {
          const parentIndex = updatedList.findIndex(c => c.categoryId === newCategory.parent);
          const parentLevel = updatedList[parentIndex].level;

          let insertIndex = parentIndex + 1;
          while (
            insertIndex < updatedList.length &&
            updatedList[insertIndex].level > parentLevel
          ) {
            insertIndex++;
          }

          updatedList.splice(insertIndex, 0, newCategory);
        } else {
          updatedList.push(newCategory);
        }

        setCategoryList(updatedList);
      }

      if (formData?.categoryId) {
        const oldIndex = categoryList.findIndex(c => c.categoryId === formData?.categoryId);
        const oldItem = categoryList[oldIndex];

        const oldParentId = oldItem?.parent;
        const newParentId = newCategory?.parent;

        if (oldParentId === newParentId) {
          updatedList[oldIndex] = {
            ...oldItem,
            ...newCategory,
          };
          setCategoryList(updatedList);
        } else {
          const { descendants, endIndex } = getDescendants(
            categoryList,
            oldIndex,
            oldItem?.level
          );

          const block = [
            {
              ...oldItem,
              ...newCategory,
            },
            ...descendants,
          ];

          block.forEach((item, i) => {
            if (i === 0) return;
            item.level = block[0].level + i;
          });

          updatedList = [
            ...categoryList.slice(0, oldIndex),
            ...categoryList.slice(endIndex),
          ];

          if (newParentId) {
            const parentIndex = updatedList?.findIndex(c => c?.categoryId === newParentId);
            const parentLevel = updatedList[parentIndex].level;

            let insertIndex = parentIndex + 1;
            while (
              insertIndex < updatedList.length &&
              updatedList[insertIndex].level > parentLevel
            ) {
              insertIndex++;
            }

            updatedList.splice(insertIndex, 0, ...block);
          } else {
            updatedList.push(...block);
          }

          setCategoryList(updatedList);
        }
      }

      setFormData({
        name: '',
        slug: '',
        description: '',
        parent: '',
        bannerId: '',
        categoryId: null
      });
      setErrorMessage({});
      setShowAddCategoryPopup(false);
      fetchData();
      fetchAllCategoryData()
    } catch (error) {
      console.log("Category submit error:", error);
      const message =
        error.response?.data?.error?.message ||
        'Something went wrong. Please try again.';
      setError(message);
      setIsLoading(false)
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async () => {
    fetchData();
  }

  return (
    <div className={`category-list ${styles.productList} ${categoryList?.length <= 10 && `${styles.productListHeight}`}`}>
      <TopBar />
      <div className={`${styles.productDatatableList}`}>
        <div className={`${styles.productHeader}`}>
          <div className={`${styles.leftSide}`}>
            <div className={`${styles.searchBar}`}>
              <img src={searchIcon} alt="Search" />
              <input
                type="text"
                placeholder="Search categories..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              />
            </div>
            <button className={`${styles.addBtn}`} onClick={() => handleSearch()}>Search</button>
          </div>
          <div className={`${styles.actionButtonsDeleteAdd}`}>
            <button className={`${styles.addBtn}`} onClick={() => { setShowAddCategoryPopup(true); setErrorMessage({}); setFormData({}); setError('') }}>Add Category</button>
            {selectedRows?.length > 0 && (
              <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                setDeleteTarget({ type: "multiple", rows: selectedRows });
                setShowDeletePopup(true);
              }}>
                <img src={Delete} alt="delete-icon" />
              </div>
            )}
          </div>
        </div>

        <div className={`categoryTable dataTable-list ${categoryList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
          <DataTableList
            columns={columns}
            data={categoryList}
            onSelectedRowsChange={({ selectedRows }) => {
              const selectedIds = selectedRows.map((row) => row?.categoryId);
              setSelectedRows(selectedIds);
              setIsAllSelected(selectedIds.length === categoryList.length);
            }}
            progressPending={isLoadingFetchData}
            currentPage={currentPage}
            onChangePage={setCurrentPage}
            paginationTotalRows={totalPage}
            selectableRows
            selectAllRows={isAllSelected}
            clearSelectedRows={toggleSelect}
            onSelectAllChange={handleMasterCheckboxChange}
            customStyles={customStyles}
            selectableRowsComponent="input"
            progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
          />
        </div>
      </div>
      <DeleteConfirmationPopup
        showDeletePopup={showDeletePopup}
        setShowDeletePopup={setShowDeletePopup}
        reference={popupRef}
        title={deleteTarget?.type === "single" ? 'category' : selectedRows?.length === 1 ? 'category' : `categories`}
        description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.name}?` : selectedRows?.length === 1 ? `Are you sure you want to delete category?` : `Are you sure you want to delete ${selectedRows?.length} categories?`}
        confirmDelete={confirmDelete}
        error={error}
        isLoading={isLoading}
      />
      <AddCategory
        showAddCategoryPopup={showAddCategoryPopup}
        popupRef={addPopupRef}
        errorMessage={errorMessage}
        formData={formData}
        handleChange={handleChange}
        setShowAddCategoryPopup={setShowAddCategoryPopup}
        handleSubmit={handleSubmit}
        handleParentSelect={handleParentSelect}
        openParent={openParent}
        setOpenParent={setOpenParent}
        parentDropdownRef={parentDropdownRef}
        bannerList={bannerList}
        handleBannerSelect={handleBannerSelect}
        bannerDropdownRef={bannerDropdownRef}
        setOpenBanner={setOpenBanner}
        openBanner={openBanner}
        allCategoryList={allCategoryList}
        isSlugChanged={isSlugChanged}
        setIsSlugChanged={setIsSlugChanged}
        setFormData={setFormData}
        isLoading={isLoading}
        error={error}
      />
    </div>
  )
}

export default AllCategories
